import { BlogSection } from '@/types/blog';

export const intro: BlogSection = {
  id: 'intro',
  title: '',
  content: `
    <p class="text-lg text-joerg-700 mb-6">
      Zugegeben, die Idee eines "persönlichen Betriebssystems" klingt erstmal... speziell. Irgendwo zwischen dem Einkaufszettel eines Roboters und dem Tagebuch eines Vulkaniers. Für mich ist es jedoch das entscheidende Werkzeug, um im täglichen Wahnsinn aus Projekten, Kundenanfragen und strategischen Zielen nicht nur zu überleben, sondern <strong>bewusst zu gestalten</strong>.
    </p>
    
    <p class="mb-4">
      Dieses "Betriebssystem" ist kein starres Manifest, sondern das Ergebnis eines fortlaufenden Dialogs mit einem digitalen Gegenüber, das ich (mit Engelsgeduld) darauf trainiert habe, als mein strategischer Sparringspartner zu agieren.
    </p>
    
    <p class="mb-4">
      In diesem sehr persönlichen Artikel öffne ich den Maschinenraum. Ich teile keine magische Formel für Erfolg, sondern ein <strong>funktionierendes Framework</strong>, das sich ständig weiterentwickelt. Es ist mein Versuch, Klarheit zu schaffen, den Fokus zu schützen und Entscheidungen zu treffen, die auf definierten Prinzipien statt auf dem Zufall basieren.
    </p>
    
    <p class="mb-4">
      Vielleicht inspiriert es dich, über die ungeschriebenen Regeln deines eigenen Systems nachzudenken. Denn am Ende stellt sich für jeden von uns im Business die gleiche Frage: <em>Agieren wir nach Plan oder nach Laune?</em>
    </p>
  `
};
